import {notifyChange, shouldNotify} from './unsavedChanges';

export default (message, callback) => {
  if (shouldNotify) notifyChange(() => callback(true), () => callback(false));
  else callback(true);
};
